module.exports = __webpack_public_path__ + "img/478.fe2baa38.png";